
const Config = window.Configs;
export const ApplicationName = Config.ApplicationName;
export const ApplicationSubTitle = Config.ApplicationSubTitle;
export const googleAPIKey = Config.googleAPIKey;
export const showGoogleImage = Config.showGoogleImage;
export const locationSearchSources = Config.locationSearchSources;
export const initialExtent = Config.initialExtent;
export const operationalMapUrl = Config.operationalMapUrl;
export const operationalLayerName = Config.operationalLayerName;
export const operationalLayerUrl = Config.operationalLayerUrl;
export const proxyDomain = Config.proxyDomain;
export const useSearchCache = Config.useSearchCache;
export const quickmaps = Config.quickmaps;
export const baseMapLayers = Config.baseMapLayers;
export const assessorInfo = Config.assessorInfo;
export const operationalLayers = Config.operationalLayers;
export const bufferOperationalFeature = Config.bufferOperationalFeature;
export const tracing = Config.tracing;
//export const ProjectionInfo = Config.ProjectionInfo;
export const PrintServiceUrl = Config.PrintServiceUrl;
export const DisclaimerMessage = Config.DisclaimerMessage;
export const ShowScalebar = Config.ShowScalebar;
export const LegendExcludeItems = Config.LegendExcludeItems;
export const LegendOperationalLayerTitle = Config.LegendOperationalLayerTitle;
export const GoogleAnaltyticsID = Config.GoogleAnaltyticsID;
export const IsDisplayDateUTC = Config.IsDisplayDateUTC;
export const ShowGoogleStreetView = Config.ShowGoogleStreetView;
export const MapMinZoom = Config.MapMinZoom;
export const MapMaxZoom = Config.MapMaxZoom;
export const SearchToolText = Config.SearchToolText;
export const Version = Config.Version;
export const planAreaLayerName = Config.planAreaLayerName;
export const planAreafields = Config.planAreafields;
export const ExcludeDetailFields = Config.ExcludeDetailFields;
export const GeometryServiceURL = Config.GeometryServiceURL;
export const GeocodeURL = Config.GeocodeURL;
export const SearchLocationEnabled = Config.SearchLocationEnabled;
export const ShowDisclaimerOnPageLoad = Config.ShowDisclaimerOnPageLoad;

